import { css } from '@emotion/react';

const ExpandCollapseSectionsStyles = css`
    font-family: var(--font-family-regular);
    font-size: var(--font-size-regular);

    .section-label {
        display: flex;
        justify-content: space-between;
        cursor: pointer;

        > p {
            margin: 0;
        }
    }

    .section-content {
        width: 100%;
    }
`;

export default ExpandCollapseSectionsStyles;
